import ProfileDashboard from './views/profileDashboard/ProfileDashboard.vue';
import Profile from './Profile.vue';
import { completionRoutes } from './views/completion/routes';

export const profileRoutes = [
  {
    path: 'profile',
    component: Profile,
    children: [
      ...completionRoutes,
      { path: '', component: ProfileDashboard, name: 'profile' }
    ]
  }];
